import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'
import mypetrolPages from './mypetrol'
import myboatPages from './myboat'
import mydieselPages from './mydiesel'
import ehailingPages from './ehailing'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  // { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/registerindividual', component: () => import('@/views/login/registerindividual'), hidden: true },
  { path: '/registercompany', component: () => import('@/views/login/registercompany'), hidden: true },
  { path: '/registercorporation', component: () => import('@/views/login/registercorporation'), hidden: true },
  { path: '/registercompanyehailing', component: () => import('@/views/login/registercompanyehailing'), hidden: true },
  // { path: '/register', component: () => import('@/views/register/index'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  // { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  // { path: '/faq', component: () => import('@/views/faq/index'), hidden: true },
  // { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/htpjpj', component: () => import('@/views/login/htpjpj'), hidden: true },
  { path: '/semak_kenderaan', component: () => import('@/views/home/semakkenderaan'), hidden: true },
  { path: '/pengenalan', component: () => import('@/views/home/pengenalan'), hidden: true },
  { path: '/cara_memohon', component: () => import('@/views/home/caramemohon'), hidden: true },
  { path: '/syarat_kelayakan', component: () => import('@/views/home/syaratkelayakan'), hidden: true },
  { path: '/hubungi_kami', component: () => import('@/views/home/hubungikami'), hidden: true },
  // { path: '/landingpagepart3', component: () => import('@/views/home/oldlandingpagepart3base'), hidden: true },
  // { path: '/v1', component: () => import('@/views/home/oldlandingpagepart3base'), hidden: true },
  // { path: '/v1', component: () => import('@/views/home/v1'), hidden: true },
  // { path: '/v2', component: () => import('@/views/home/oldindex'), hidden: true },
  // { path: '/framerv2', component: () => import('@/views/home/newlandingpagev2combined'), hidden: true },
  // { path: '/v3', component: () => import('@/views/home/v3'), hidden: true },
  // { path: '/v4', component: () => import('@/views/home/v4'), hidden: true },
  { path: '/confirmation', component: () => import('@/views/home/confirmation'), hidden: true },
  // { path: '/confirmation-success', component: () => import('@/views/home/confirmation-success'), hidden: true },
  // { path: '/legal', component: () => import('@/views/legal/legal-replacement'), hidden: true },
  // { path: '/privacy', component: () => import('@/views/legal/privacy-replacement'), hidden: true },
  // { path: '/cookie', component: () => import('@/views/legal/cookie-replacement'), hidden: true },
  // { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },
  { path: '/maintenance', component: () => import('@/views/home/maintenance'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const adminWaitingRouterMap = [
  { path: '/z/:branchId/default', component: () => import('@/views/unconfirmed/adminwaiting'), hidden: true },
]

export const asyncRouterMap = [
  ...mypetrolPages,
  ...mydieselPages,
  ...myboatPages,
  ...ehailingPages,
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default' }
      }
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/mysubsidi/overview',
    component: Layout,
    redirect: '',
    name: 'MySubsidi',
    meta: { title: 'Overview', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/home/overview'),
        meta: { title: 'MySubsidi', icon: 'ow_clock1' }
      }
    ],
    hidden: true
  },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users' }
    }]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js